export default [

     {
          path: '/emergency-equipment',
          name: 'EmergencyEquipment',
          component: () => import("@/views/Page/EmergencyEquipment/EmergencyEquipment.vue"),
           meta: {
               title: 'EmergencyEquipment',
          },
     }
];